import PropTypes from 'prop-types';
import React from 'react';

import Keyset from './Keyset';

const Card = (props) => (
  <article className="ncss-col-sm-12 ncss-col-lg-6 va-sm-t" style={{ float: 'left', marginBottom: '20px', paddingBottom: '10px' }}>
    <h2 className="body-1">{props.header}</h2>
    <section className="border bg-primary-grey p2-sm" style={{ height: '309px', overflowY: 'scroll' }}>
      {props.keys.map((key) => (
        <Keyset
          key={key.key}
          accessToken={props.accessToken}
          allStores={props.allStores}
          currentPair={props.currentConfig.find((pair) => pair.key === key.key)}
          currentStore={props.store}
          description={key.description}
          group={props.header}
          isReadOnly={props.isReadOnly}
          name={key.key}
          scsRegion={props.scsRegion}
          type={key.valueType}
          userInfo={props.userInfo}
          onSave={props.onSave}
        />
      ))}
    </section>
  </article>
);

Card.defaultProps = {
  isReadOnly: true,
};

Card.propTypes = {
  accessToken: PropTypes.string.isRequired,
  allStores: PropTypes.arrayOf(PropTypes.shape).isRequired,
  currentConfig: PropTypes.arrayOf(PropTypes.shape).isRequired,
  header: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
  keys: PropTypes.arrayOf(PropTypes.shape).isRequired,
  onSave: PropTypes.func.isRequired,
  scsRegion: PropTypes.string.isRequired,
  store: PropTypes.shape({}).isRequired,
  userInfo: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
};

export default Card;
